import React from "react";
import { Autocomplete, TextField } from "@mui/material";

// A dropdown to pick a job (used at the top of the sidebar Applicants /
// Who-Can-Apply pages).
export default function JobSelector({ jobs = [], value, onChange }) {
  return (
    <Autocomplete
      sx={{ maxWidth: { xs: "100%", sm: 520 }, width: "100%", mb: 3 }}
      options={jobs}
      getOptionLabel={(o) => (o.job_title || "") + (o.company_name ? ` · ${o.company_name}` : "")}
      isOptionEqualToValue={(o, v) => o.career_job_id === v.career_job_id}
      value={value}
      onChange={(e, v) => onChange(v)}
      renderInput={(params) => <TextField {...params} label="Select a job" />}
    />
  );
}
